export default __webpack_public_path__ + "static/media/_dots_small_icon_dark.01deca37.svg";